<template>
  <div id="app">
    <template v-if="signedInLayout">
      <div class="header">
        <Header />
        <RouterView name="subheader" />
      </div>
    </template>

    <div class="main-router-view" :class="{ authenticated: signedInLayout }">
      <RouterView />
    </div>

    <Alerts />
    <PropertyAccessDialog v-if="signedInLayout" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';

import { useAuthStore, useSignedInLayout } from '@tallo/auth';
import { Alerts } from '@tallo/design-system';
import { AppRoutes } from '@tallo/investor/navigation';
import { PropertyAccessDialog } from '@tallo/investor/property';

import Header from './components/root/header.vue';
import appInitService from './services/app-init.service';

const authStore = useAuthStore();
const router = useRouter();
const { isAuthenticated } = storeToRefs(authStore);
const signedInLayout = useSignedInLayout(AppRoutes.AUTH);

onMounted(() => {
  authStore.setupAuthenticatedFlag();
  authStore.initializeGoogleSignInClient();
  appInitService.setRouter(router);
});

watch(isAuthenticated, async () => {
  if (isAuthenticated.value) {
    await appInitService.initApp();
  } else {
    appInitService.reset();
  }
});
</script>

<style scoped lang="scss">
#app {
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    padding-inline: var(--t-app-layout-padding);
  }

  .main-router-view {
    flex: 1 0 auto;

    &.authenticated {
      flex: 1;
      width: 100%;
      padding: var(--t-app-layout-padding);
    }
  }
}
</style>
